var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from '../class-transformer-custom';
/**
 * Player stats: played games, preferred settings...
 *
 * played game: a game that has finished (not canceled, with at least 4 moves, swap included).
 */
export default class PlayerStats {
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PlayerStats.prototype, "totalPlayedGames", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PlayerStats.prototype, "totalRanked", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PlayerStats.prototype, "totalFriendly", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], PlayerStats.prototype, "totalBotGames", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], PlayerStats.prototype, "preferredBoardsizes", void 0);
